import { render } from "./DepensesManager.vue?vue&type=template&id=392acb40&scoped=true"
import script from "./DepensesManager.vue?vue&type=script&lang=js"
export * from "./DepensesManager.vue?vue&type=script&lang=js"

import "./DepensesManager.vue?vue&type=style&index=0&id=392acb40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392acb40"]])

export default __exports__